import React from 'react'
import { Link } from 'react-router-dom'

const SCREENS = [
  'create-account','start','new-farm','type-culture','species','stage','production-unit','navegate','home','reports','dashboard-new','database','water','feed','biomas','todos','dashboard'
]

export default function ScreensIndex(){
  return (
    <div>
      <h2 className="h2">All Screens</h2>
      <ul>
        {SCREENS.map(s=> (
          <li key={s}><Link to={`/${s}`}>{s}</Link></li>
        ))}
      </ul>
    </div>
  )
}
